export default __webpack_public_path__ + "3745f012b80b818f2635b79c81adf52c.png";